import { render, staticRenderFns } from "./BuildingTimeDivisionArray.vue?vue&type=template&id=224970fe&"
import script from "./BuildingTimeDivisionArray.vue?vue&type=script&lang=js&"
export * from "./BuildingTimeDivisionArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports